import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

// eslint-disable-next-line import/no-named-as-default
import App from './App';
import './i18n/config';
import './index.css';
import { QueryProvider } from './lib/queryClient';
import { store } from './store';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryProvider>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </QueryProvider>
  </StrictMode>
);

// Service worker registration is handled automatically by vite-plugin-pwa (registerSW.js).
// Do NOT register manually here — duplicate registrations cause race conditions
// that can prevent the PWA from launching in standalone mode.
